'use strict';

import type { UserLetter } from '../../Entities/User/UserLetter';
import { EntityCollection } from '../EntityCollection';

export class UserLetterCollection extends EntityCollection<UserLetter> {}
